import BaseService from '../BaseService';

class OrderInService extends BaseService {
    getAll = (filters) => this.post('/warehouse/orders/in', filters || { });

    getOne = (id) => this.get(`/warehouse/order/in/${id}`);

    deleteOne = (id) => this.delete(`/warehouse/order/in/${id}`);

    addOrder = (data) => this.post('/warehouse/order/in', data);

    getProductPriceDetails = (data) => this.post('/warehouse/product/priceDetails', data);

    readFromBarcode = (data) => this.post('/warehouse/product/searchBarcode', data);

    changeStatus = (data) => this.put('/warehouse/order/updateStatus', data);
}

export default new OrderInService();